import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import ProtectedRoute from '../components/ProtectedRoute';
import ArchiveProtectedRoute from '../components/archive/ArchiveProtectedRoute';

const Home = lazy(() => import('../pages/home/page'));
const RootEntry = lazy(() => import('../pages/RootEntry'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const CourseDetail = lazy(() => import('../pages/course/page'));
const Board = lazy(() => import('../pages/board/page'));
const BoardDetail = lazy(() => import('../pages/board/detail/page'));
const BoardWrite = lazy(() => import('../pages/board/write/page'));
const BoardEdit = lazy(() => import('../pages/board/edit/page'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminCourses = lazy(() => import('../pages/admin/courses/page'));
const AdminUsers = lazy(() => import('../pages/admin/users/page'));
const AdminPermissions = lazy(() => import('../pages/admin/permissions/page'));
const SuperLogin = lazy(() => import('../pages/super/login/page'));
const SuperDashboard = lazy(() => import('../pages/super/dashboard/page'));
const SuperTenants = lazy(() => import('../pages/super/tenants/page'));
const SuperTenantDetail = lazy(() => import('../pages/super/tenants/detail/page'));
const SuperBilling = lazy(() => import('../pages/super/billing/page'));
const SuperAuditLogs = lazy(() => import('../pages/super/audit-logs/page'));
const ArchiveLogin = lazy(() => import('../pages/archive/login/page'));
const ArchiveSignup = lazy(() => import('../pages/archive/signup/page'));
const ArchiveDrive = lazy(() => import('../pages/archive/drive/page'));
const ArchiveAdmin = lazy(() => import('../pages/archive/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootEntry />,
  },
  {
    path: '/archive/login',
    element: <ArchiveLogin />,
  },
  {
    path: '/archive/signup',
    element: <ArchiveSignup />,
  },
  {
    path: '/archive',
    element: (
      <ArchiveProtectedRoute>
        <ArchiveDrive />
      </ArchiveProtectedRoute>
    ),
  },
  {
    path: '/archive/admin',
    element: (
      <ArchiveProtectedRoute admin>
        <ArchiveAdmin />
      </ArchiveProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute allow={['user']}>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/course/:courseId',
    element: (
      <ProtectedRoute allow={['user']}>
        <CourseDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: '/board',
    element: (
      <ProtectedRoute allow={['admin', 'user']}>
        <Board />
      </ProtectedRoute>
    ),
  },
  {
    path: '/board/write',
    element: (
      <ProtectedRoute allow={['admin', 'user']}>
        <BoardWrite />
      </ProtectedRoute>
    ),
  },
  {
    path: '/board/edit/:postId',
    element: (
      <ProtectedRoute allow={['admin', 'user']}>
        <BoardEdit />
      </ProtectedRoute>
    ),
  },
  {
    path: '/board/:postId',
    element: (
      <ProtectedRoute allow={['admin', 'user']}>
        <BoardDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/dashboard',
    element: (
      <ProtectedRoute allow={['admin']}>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/courses',
    element: (
      <ProtectedRoute allow={['admin']}>
        <AdminCourses />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/users',
    element: (
      <ProtectedRoute allow={['admin']}>
        <AdminUsers />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/permissions',
    element: (
      <ProtectedRoute allow={['admin']}>
        <AdminPermissions />
      </ProtectedRoute>
    ),
  },
  {
    path: '/super/login',
    element: <SuperLogin />,
  },
  {
    path: '/super/dashboard',
    element: (
      <ProtectedRoute allow={['super']}>
        <SuperDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/super/tenants',
    element: (
      <ProtectedRoute allow={['super']}>
        <SuperTenants />
      </ProtectedRoute>
    ),
  },
  {
    path: '/super/tenants/:id',
    element: (
      <ProtectedRoute allow={['super']}>
        <SuperTenantDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: '/super/billing',
    element: (
      <ProtectedRoute allow={['super']}>
        <SuperBilling />
      </ProtectedRoute>
    ),
  },
  {
    path: '/super/audit-logs',
    element: (
      <ProtectedRoute allow={['super']}>
        <SuperAuditLogs />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
